import _ from 'lodash'
import { action, makeObservable, observable, reaction } from 'mobx'
import ApiService from 'src/services/apiService'
import { MasterWorkoutExercise, MasterWorkoutExerciseSet } from 'src/types/MasterWorkoutExercise'

export default class MasterWorkoutExerciseViewModel {
	public masterWorkoutExercise: MasterWorkoutExercise = {
		id: null,
		masterWorkoutId: null,
		masterGroupId: 0,
		masterGroupName: null,
		masterExerciseId: null,
		masterExerciseName: null,
		masterExerciseOptionIds: [],
		sets: null,
		calculatedWeight: null,
		reps: null,
		week: null,
		day: null,
		repRange: null,
		rir: null,
		tempo: null,
		rest: null,
		intensityTechnique: null,
		percentageOfMax: null,
		maxConservative: null,
		maxModerate: null,
		maxHigh: null,
		multiplier: null,
		note: null,
		displayOrder: null,
		resultListOrder: null,
		masterWorkoutExerciseGroupAccessTermIds: [],
		masterWorkoutExerciseGroupFilterTermIds: [],
		masterWorkoutExerciseSets: [],
	}

	constructor(private service: ApiService, masterWorkoutExercise: MasterWorkoutExercise) {
		if (masterWorkoutExercise) this.masterWorkoutExercise = Object.assign(this.masterWorkoutExercise, masterWorkoutExercise)

		makeObservable<MasterWorkoutExerciseViewModel>(this, {
			masterWorkoutExercise: observable,
			updateOrder: action,
			applyBatchEdit: action,
			submitMasterWorkoutExercise: action,
			// sets
			addSet: action,
			removeSet: action,
			editSet: action,
		})

		reaction(
			() => this.masterWorkoutExercise.masterWorkoutExerciseSets,
			(sets) => {
				this.masterWorkoutExercise = { ...this.masterWorkoutExercise, sets: sets.length }
			},
		)
	}

	public updateMasterWorkoutExerciseOrder = (order: number): void => {
		const { day } = this.masterWorkoutExercise
		this.updateOrder(order, day)
	}

	public updateOrder = (order: number, day: number): void => {
		this.masterWorkoutExercise.day = day
		this.masterWorkoutExercise.displayOrder = order

		// Autosubmit
		this.submitMasterWorkoutExercise()
		console.log('@ApiService->updateOrder')
	}

	/**
	 * ************************************************
	 *  Sets
	 * ************************************************
	 */
	public addSet = (): void => {
		const currentSetCount = this.masterWorkoutExercise.masterWorkoutExerciseSets.length
		this.masterWorkoutExercise.masterWorkoutExerciseSets = [
			...this.masterWorkoutExercise.masterWorkoutExerciseSets,
			{
				id: null,
				displayOrder: currentSetCount,
				isChild: false,
				isToFailure: false,
				note: null,
				masterWorkoutExerciseId: this.masterWorkoutExercise.id,
			},
		]

		// Autosubmit
		this.submitMasterWorkoutExercise()
		console.log('@ApiService->addSet')
	}

	public removeSet = (idx: number): void => {
		const newArray = [...this.masterWorkoutExercise.masterWorkoutExerciseSets]
		newArray.splice(idx, 1)

		// update display order
		this.masterWorkoutExercise.masterWorkoutExerciseSets = newArray.map((x, idx) => ({ ...x, displayOrder: idx }))

		// Autosubmit
		this.submitMasterWorkoutExercise()
		console.log('@ApiService->removeSet')
	}

	public editSet = (idx: number, value: MasterWorkoutExerciseSet): void => {
		const newArray = [...this.masterWorkoutExercise.masterWorkoutExerciseSets]
		newArray[idx] = value
		this.masterWorkoutExercise.masterWorkoutExerciseSets = newArray

		// Autosubmit
		this.submitMasterWorkoutExercise()
		console.log('@ApiService->editSet', idx, value)
	}

	public submitMasterWorkoutExercise = _.debounce((value?: MasterWorkoutExercise): void => {
		if (value)
			this.masterWorkoutExercise = {
				...value,
				id: this.masterWorkoutExercise.id,
				sets: this.masterWorkoutExercise.sets,
				masterWorkoutExerciseSets: this.masterWorkoutExercise.masterWorkoutExerciseSets,
			}

		if (this.masterWorkoutExercise.masterExerciseId > 0) {
			this.service.submitMasterWorkoutExercise(this.masterWorkoutExercise).then((id) => {
				this.masterWorkoutExercise.id = id
			})
		}

		console.log('@ApiService->submitMasterWorkoutExercise', this.masterWorkoutExercise)
	}, 2000)

	public applyBatchEdit = (values: any): void => {
		if (values) {
			Object.keys(values).forEach((key) => {
				this.masterWorkoutExercise[key] = values[key]
			})
		}
		// Autosubmit
		this.submitMasterWorkoutExercise()
		console.log('@ApiService->applyBatchEdit', values)
	}

	public validateMasterWorkoutExercise = (values: MasterWorkoutExercise) => {
		const errors: any = {}
		if (!values.masterExerciseId) {
			errors.masterExerciseId = 'Exercise is Required'
		}
		return errors
	}
}
